import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import Navbar from "@/pages/home/components/Navbar";
import CTAFooterSection from "@/pages/home/components/CTAFooterSection";
import PaymentPanel from "../components/PaymentPanel";

// Página de pagamento para inscritas aprovadas. Só abre com ?r=<id>&t=<token> válidos
// (a checagem fica na função event_payment_info, no banco).
export default function UpcomingEventPaymentPage() {
  const [params] = useSearchParams();
  const [state, setState] = useState<"loading" | "ok" | "invalid">("loading");
  const [info, setInfo] = useState<{ name: string; event_title: string } | null>(null);

  useEffect(() => {
    const id = Number(params.get("r"));
    const token = params.get("t") || "";
    if (!id || !token) {
      setState("invalid");
      return;
    }
    supabase.rpc("event_payment_info", { p_id: id, p_token: token }).then(({ data, error }) => {
      const linha = Array.isArray(data) ? data[0] : null;
      if (error || !linha) {
        setState("invalid");
        return;
      }
      setInfo(linha as { name: string; event_title: string });
      setState("ok");
    });
  }, [params]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-24 md:pt-32 bg-beige">
        {state === "loading" && (
          <div className="py-24 text-center">
            <p className="font-body text-sm text-brown/60">Carregando...</p>
          </div>
        )}

        {state === "invalid" && (
          <div className="py-24 px-6 text-center">
            <h2 className="font-display text-xl text-brown mb-2">Link inválido</h2>
            <p className="font-body text-sm text-brown/60">
              Este link de pagamento não é válido ou expirou. Chame a equipe no WhatsApp +1 (205) 892-5956.
            </p>
          </div>
        )}

        {state === "ok" && info && <PaymentPanel eventTitle={info.event_title} name={info.name} />}
      </div>
      <CTAFooterSection />
    </div>
  );
}
